/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router";

class Breadcrumb extends React.Component {
    static propTypes = {
        /**
         * Breadcrumb links. Last item will be shown without link
         */
        links: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            to: PropTypes.string
        })).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderItems() {
        if (!this.props.links) return "";
        let items = [];
        for (let i = 0; i < this.props.links.length-1; i++) {
            let item = this.props.links[i];
            items.push(
                <li key={i}>
                    <Link to={item.to}>{item.title}</Link>
                </li>
            );
        }
        if (this.props.links.length > 0) {
            items.push(
                <li key={this.props.links.length-1} className="active">
                    <strong>{this.props.links[this.props.links.length-1].title}</strong>
                </li>
            );
        }
        return items;
    }

    render() {
        return (
            <ol className="breadcrumb pull-left">
                {this.renderItems()}
            </ol>
        );
    }
}

export default Breadcrumb;
